
const state = {
    routes:[
    //     {
    //     meta:{
    //         name:'首页',
            
    //     },
    //     path:'/homeMain'
    // }
]
}

const mutations = {
    SET_ROUTERS:(state,n) =>{
        state.routes.push(n)
        console.log(state.routes,n,'52113123');
    }
}

export default {
    namespaced: true,
    state,
    mutations,
  }